var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.75 6.75033C3.75 6.75033 7.5 3.75033 12 6.75033 16.5 9.75032 20.25 6.75033 20.25 6.75033M3.75 12.0003C3.75 12.0003 7.5 9.00033 12 12.0003 16.5 15.0003 20.25 12.0003 20.25 12.0003M3.75 17.2503C3.75 17.2503 7.5 14.2503 12 17.2503 16.5 20.2503 20.25 17.2503 20.25 17.2503", stroke: "#222429", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});